import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import "react-toastify/dist/ReactToastify.css";
import Booking from "./pages/Booking";
import Termandpolicies from "./pages/Termandpolicies";
import About from "./pages/About";
import Policies from "./pages/Policies";
import SubAdminManagement from "./pages/SubAdminManagement";
import Notification from "./pages/Notification";
import Reports from "./pages/Reports";
import Contentmanagement from "./pages/Contentmanagement";
import Setting from "./pages/Setting";
import AddSubAdmin from "./pages/AddSubAdmin";
import Transaction from "./pages/Transaction";
import Chat from "./pages/Chat";
import Offer from "./pages/Offer";
import Commission from "./pages/Commission";
import BookingDetails from "./pages/BookingDetails";
import BookingRequest from "./pages/BookingRequest";
import EditSubAdmin from "./pages/EditSubAdmin";
import WithDraw from "./pages/WithDraw";
import AdminTransaction from "./pages/AdminTransaction";
import BookingCancelRequest from "./pages/BookingCancelRequest";
import EndTrip from "./pages/EndTrip";
import BannerManagement from "./pages/BannerManagement";
import CustomMessage from "./pages/CustomMessage";
import Language from "./pages/Languages";
import UserDetails from "./pages/UserDetails";
import UserList from "./pages/UserList";
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import ModuleGuard from "./PrivateRoute/ModuleGuard";
import { ToastContainer } from "react-toastify";
import CarerAvailability from "./pages/CarerAvailability";
import PackageBenefits from "./pages/PackageBenefits";
import PackageComparisonPreview from "./pages/PackageComparisonPreview";
import ChecklistManager from "./pages/ChecklistManager";
import AppConfig from "./pages/AppConfig";
import OtpExceptions from "./pages/OtpExceptions";
import PricingSimulator from "./pages/PricingSimulator";
import Layout from "./layout/Layout";
import FaqManagement from "./pages/FaqManagement";
import KnowledgeBaseHub from "./pages/KnowledgeBase/KnowledgeBaseHub";
import DocumentationHub from "./pages/Documentation/DocumentationHub";
import KnowledgeBaseForm from "./pages/KnowledgeBase/KnowledgeBaseForm";
import MatchboardRequests from "./pages/MatchboardRequests";
import ContactForms from "./pages/ContactForms";
import WhatsAppSettings from "./pages/WhatsAppSettings";
import ChatSupportList from "./pages/ChatSupportList";
import ChatSupportDetail from "./pages/ChatSupportDetail";
import SupportKbHub from "./pages/SupportKnowledgeBase/SupportKbHub";
import SupportKbForm from "./pages/SupportKnowledgeBase/SupportKbForm";
import ApiLogs from "./pages/ApiLogs";

function App() {
  return (
    <Router>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/forgetpassword" element={<ForgetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        {/* PRIVATE ROUTES */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Routes>
                <Route path="/dashboard" element={<ModuleGuard modulePath="/dashboard"><Dashboard /></ModuleGuard>} />
                <Route
                  path="/users"
                  element={
                    <ModuleGuard modulePath="/users">
                      <UserList
                        detailsRoute="/users/"
                        title="Users"
                        defaultFilters={{ is_deleted: false }}
                      />
                    </ModuleGuard>
                  }
                />
                <Route path="/users/:id" element={<ModuleGuard modulePath="/users"><UserDetails /></ModuleGuard>} />
                <Route path="/content-management" element={<ModuleGuard modulePath="/content-management"><Contentmanagement /></ModuleGuard>} />
                <Route path="/add-sub-admin" element={<ModuleGuard modulePath="/sub-admin-management"><AddSubAdmin /></ModuleGuard>} />
                <Route
                  path="/booking-request-from-care-seeker"
                  element={<ModuleGuard modulePath="/booking-request-from-care-seeker"><BookingRequest /></ModuleGuard>}
                />
                <Route path="/withdraw" element={<ModuleGuard modulePath="/withdraw"><WithDraw defaultTab="requests" /></ModuleGuard>} />
                <Route path="/carer-withdrawals" element={<ModuleGuard modulePath="/carer-withdrawals"><WithDraw defaultTab="requests" /></ModuleGuard>} />
                <Route path="/admin-transaction" element={<ModuleGuard modulePath="/admin-transaction"><AdminTransaction /></ModuleGuard>} />
                <Route
                  path="/booking-cancel-request"
                  element={<ModuleGuard modulePath="/booking-cancel-request"><BookingCancelRequest /></ModuleGuard>}
                />
                <Route path="/end-trip" element={<ModuleGuard modulePath="/end-trip"><EndTrip /></ModuleGuard>} />
                <Route path="/language" element={<ModuleGuard modulePath="/language"><Language /></ModuleGuard>} />
                <Route path="/transaction" element={<ModuleGuard modulePath="/transaction"><Transaction /></ModuleGuard>} />
                <Route path="/chat" element={<ModuleGuard modulePath="/chat"><Chat /></ModuleGuard>} />
                <Route path="/offer" element={<ModuleGuard modulePath="/offer"><Offer /></ModuleGuard>} />
                <Route path="/commission" element={<ModuleGuard modulePath="/commission"><Commission /></ModuleGuard>} />
                <Route path="/booking" element={<ModuleGuard modulePath="/booking"><Booking /></ModuleGuard>} />
                <Route path="/booking-details/:id" element={<ModuleGuard modulePath="/booking"><BookingDetails /></ModuleGuard>} />
                <Route path="/terms" element={<Termandpolicies />} />
                <Route path="/about" element={<About />} />
                <Route path="/policies" element={<Policies />} />
                <Route path="/notifications" element={<ModuleGuard modulePath="/notifications"><Notification /></ModuleGuard>} />
                <Route path="/report" element={<ModuleGuard modulePath="/report"><Reports /></ModuleGuard>} />
                <Route path="/settings" element={<ModuleGuard modulePath="/setting"><Setting /></ModuleGuard>} />
                <Route path="/update-subadmin/:id" element={<ModuleGuard modulePath="/sub-admin-management"><EditSubAdmin /></ModuleGuard>} />
                <Route path="/banner-management" element={<ModuleGuard modulePath="/banner-management"><BannerManagement /></ModuleGuard>} />
                <Route path="/custom-message" element={<ModuleGuard modulePath="/custom-message"><CustomMessage /></ModuleGuard>} />
                <Route path="/sub-admin-management" element={<ModuleGuard modulePath="/sub-admin-management"><SubAdminManagement /></ModuleGuard>} />
                <Route path="/admin/carers/availability" element={<ModuleGuard modulePath="/admin/carers/availability"><CarerAvailability /></ModuleGuard>} />
                <Route path="/package-benefits" element={<ModuleGuard modulePath="/package-benefits"><PackageBenefits /></ModuleGuard>} />
                <Route path="/package-preview" element={<ModuleGuard modulePath="/package-benefits"><PackageComparisonPreview /></ModuleGuard>} />
                <Route path="/checklist-manager" element={<ModuleGuard modulePath="/checklist-manager"><ChecklistManager /></ModuleGuard>} />
                <Route path="/app-config" element={<ModuleGuard modulePath="/app-config"><AppConfig /></ModuleGuard>} />
                <Route path="/whatsapp-settings" element={<ModuleGuard modulePath="/whatsapp-settings"><WhatsAppSettings /></ModuleGuard>} />
                <Route path="/otp-exceptions" element={<ModuleGuard modulePath="/otp-exceptions"><OtpExceptions /></ModuleGuard>} />
                <Route path="/pricing-simulator" element={<ModuleGuard modulePath="/pricing-simulator"><Layout><PricingSimulator /></Layout></ModuleGuard>} />
                <Route path="/faqs" element={<ModuleGuard modulePath="/faqs"><FaqManagement /></ModuleGuard>} />
                <Route path="/knowledge-base" element={<ModuleGuard modulePath="/knowledge-base"><KnowledgeBaseHub /></ModuleGuard>} />
                <Route path="/knowledge-base/contribute" element={<ModuleGuard modulePath="/knowledge-base"><KnowledgeBaseForm /></ModuleGuard>} />
                <Route path="/knowledge-base/edit/:id" element={<ModuleGuard modulePath="/knowledge-base"><KnowledgeBaseForm /></ModuleGuard>} />
                <Route path="/support-knowledge-base" element={<ModuleGuard modulePath="/support-knowledge-base"><SupportKbHub /></ModuleGuard>} />
                <Route path="/support-knowledge-base/contribute" element={<ModuleGuard modulePath="/support-knowledge-base"><SupportKbForm /></ModuleGuard>} />
                <Route path="/support-knowledge-base/edit/:id" element={<ModuleGuard modulePath="/support-knowledge-base"><SupportKbForm /></ModuleGuard>} />
                <Route path="/documentation/*" element={<Layout><DocumentationHub /></Layout>} />
                <Route path="/matchboard-requests" element={<ModuleGuard modulePath="/matchboard-requests"><MatchboardRequests /></ModuleGuard>} />
                <Route path="/contact-forms" element={<ModuleGuard modulePath="/contact-forms"><ContactForms /></ModuleGuard>} />
                <Route path="/chat-support" element={<ModuleGuard modulePath="/chat-support"><ChatSupportList /></ModuleGuard>} />
                <Route path="/chat-support/:id" element={<ModuleGuard modulePath="/chat-support"><ChatSupportDetail /></ModuleGuard>} />
                <Route path="/api-logs" element={<ModuleGuard modulePath="/api-logs"><ApiLogs /></ModuleGuard>} />
                <Route path="/charge" element={<Navigate to="/commission" replace />} />
              </Routes>
            </PrivateRoute>
          }
        />
      </Routes>

      <ToastContainer />
    </Router>
  );
}

export default App;
